module.exports = __webpack_public_path__ + "img/oktoberfest_1.9b636587.jpg";